

<template>
  <app-auto-select
      v-bind="$attrs"
      v-on="$listeners"
      :chips="getChips"
      :clearable="clearable"
      :deletable-chips="getDeletableChips"
      :hide-no-data="getHideNoData"
      :hide-selected="!showSelected"
      :items="items"
      :lazy-model.sync="isActive"
      :loading="loading"
      :multiple="multiple"
      :small-chips="getSmallChips"
      :value="value"
      :vid="vid"
      :ref="getref"
  >
    <slot></slot>
  </app-auto-select>
</template>

<script>

export default {
  name: 'AxiosSelect',
  props: {
    value: {},
    rules: {},
    vid: {},
    append: {
      type: Object,
      default: () => ({})
    },
    refreturn: {
      type: String,
      default: () => 'gen',
      required: !1
    },
    smallChips: {
      type: Boolean,
      default: () => undefined
    },
    hideNoData: {
      type: Boolean,
      default: () => undefined
    },
    deletableChips: {
      type: Boolean,
      default: () => undefined
    },
    chips: {
      type: Boolean,
      default: () => undefined
    },
    multiple: {
      type: Boolean,
      default: () => !1
    },
    showSelected: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      default: () => false
    },
    axiosUrl: {
      type: [String, Function],
      required: !0
    },
    changable: {
      default: () => false
    },
    changableAxiosUrl: {
      type: [String, Function],
      required: false
    },
    axiosMethod: {
      type: String,
      default: () => 'get'
    },
    axiosData: {},
    axiosParams: {},
    axiosConfig: {
      type: Object,
      default: () => ({})
    },
    defaultItems: {
      type: [],
      default: () => ([])
    }
  },
  data() {
    return {
      isActive: false,
      loading: !1,
      items: [],
      fetched: false,
      fetchPending: false,
      preservedValue: null
    };
  },
  computed: {
    axiosParamsKey() {
      try {
        return JSON.stringify(this.axiosParams || {});
      } catch (e) {
        return '';
      }
    },
    getAxiosUrl() {
      return  this.changable ? this.changableAxiosUrl : this.axiosUrl;
    },
    getDeletableChips() {
      return this.deletableChips === undefined ? this.multiple : this.deletableChips;
    },
    getref() {
      return this.refreturn;
    },
    getSmallChips() {
      return this.smallChips === undefined ? this.chips : this.smallChips;
    },
    getChips() {
      return this.chips === undefined ? this.multiple : this.chips;
    },
    getHideNoData() {
      return this.hideNoData;
      return this.hideNoData === undefined ? this.multiple : this.hideNoData;
    }
  },
  methods: {
    setLoading(v) {
      this.loading = v;
    },
    setItems(v) {
      this.items = v;
    },
    getRequest(url) {
      return this.$axios.request({
        url,
        method: this.axiosMethod,
        data: this.axiosData,
        params: this.axiosParams,
        ...this.axiosConfig
      });
    },
    rememberPreservedValue() {
      if (this.preservedValue !== undefined && this.preservedValue !== null && this.preservedValue !== '') {
        return;
      }
      if (this.value !== undefined && this.value !== null && this.value !== '') {
        this.preservedValue = this.value;
      }
    },
    itemMatchesPreservedValue(item, saved) {
      if (item === undefined || item === null || saved === undefined || saved === null || saved === '') return false;
      if (typeof item !== 'object') return String(item) === String(saved);
      return [item.value, item.id].some((candidate) => candidate !== undefined && candidate !== null && String(candidate) === String(saved));
    },
    restorePreservedValue(items) {
      const saved = this.preservedValue;
      this.preservedValue = null;
      if (saved === undefined || saved === null || saved === '') return;
      const list = Array.isArray(items) ? items : [];
      if (list.some((item) => this.itemMatchesPreservedValue(item, saved))) {
        if (String(this.value) !== String(saved)) {
          this.$emit('input', saved);
          this.$emit('change', saved);
        }
        return;
      }
      if (this.value !== undefined && this.value !== null && this.value !== '') {
        this.$emit('input', null);
        this.$emit('change', null);
      }
    },
    refetchFromParams() {
      this.rememberPreservedValue();
      this.fetched = !1;
      if (this.loading) {
        this.fetchPending = true;
        return;
      }
      this.fetchData();
    },
    fetchData() {
      if(this.loading || this.fetched || (this.changable && !this.changableAxiosUrl) || !this.getAxiosUrl) return;
      const items = this.getAxiosItems();
      this.setLoading(!0);

      if(items !== undefined && items !== null) {
        this.complete(items);
        this.finally();
        return;
      }

      // this.setItems([]);

      const func = () => {
        let axios = this.$helpers.isFunction(this.getAxiosUrl) ? this.getAxiosUrl() : this.getAxiosUrl;
        this.$helpers.isString(axios) && (axios = this.getRequest(axios));

        this.$nextTick(() =>
        axios.then((request) => {
          const {data} = request || {};
          if(data && data.data && this.$helpers.isOnlyArray(data.data)) {
            this.complete(data.data, request);
            return;
          }
          this.complete([]);
        })
        .catch(() => this.complete([]))
        .finally(this.finally));
      };
      this.queueAxios(func);
    },
    complete(data) {
      if (this.fetchPending) {
        return;
      }
      this.setItems(data);
      this.setIniAxios(this.getAxiosName(), data);
      this.fetched = !0;
      this.restorePreservedValue(data);

      this.$emit('complete', ...arguments);
    },
    finally() {
      this.setLoading(!1);
      if (this.fetchPending) {
        this.fetchPending = false;
        this.fetched = !1;
        this.fetchData();
      }
    }
  },
  watch: {
    axiosParamsKey() {
      this.refetchFromParams();
    },
    items(v) {
      this.$emit('set-items', v);
    },
    changableAxiosUrl() {
      if (!this.changable) return;

      this.fetched = !1;
      if (this.defaultItems && this.defaultItems.length) {
        this.setItems(this.defaultItems);
      } else {
      this.setItems([]);

      if (this.changableAxiosUrl) {
        this.fetchData();
      }
    }
    }
    // isActive(v) {
    //   // if(v === true) {
    //   //   this.$nextTick(() => this.fetchData());
    //   // }
    //   // console.log(v);
    // }
  },
  mounted() {
    // if(this.refreturn !== 'gen'){
    //   if(this.$refs[this.refreturn].$refs){
    //     let autocompleteInput = this.$refs[this.refreturn].$refs.autocomplete.$refs.input;
    //     autocompleteInput.addEventListener('focus', this.onFocus, true)
    //   }
    // }
    // console.log(this.$options.name)
    if (this.defaultItems && this.defaultItems.length) {
      this.setItems(this.defaultItems);
    }

    this.$nextTick(() => this.fetchData());
  }
};
</script>
